<template>
  <div class="right">
    <div class="banner-div">
      <img class="right-banner" @click="addDemand" src="../../static/img/banner1.png" alt="">
    </div>
    <div class="banner-div">
      <img class="right-banner" src="../../static/img/banner2.png" alt="">
    </div>
    <el-dialog title="提出新的文档需求" :visible.sync="formVisible">  
      <div slot="title">
        <img src="../../static/img/add-q.png" alt="">
        提出新的文档需求
      </div>
      <div>
        <div class="body-item">
          <span class="body-item-title">需求描述：</span>
          <el-input 
            class="body-item-content"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="demand.describe">
          </el-input>
        </div>
        <div class="body-item">
          <span class="body-item-title">联系方式：</span>
          <el-input v-model="demand.contact" placeholder="请输入您的联系电话/邮箱"></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-button  @click="formVisible = false">关闭</el-button>
        <el-button type="primary" @click="save">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import service from '../service/demoService'
import tool from '../../static/js/public.js'
export default {
  name:'right',
  data(){
    return {
      formVisible:false,
      demand:{
        describe:'',
        contact:'',
      }
    }
  },
  watch: {
  },
  methods:{
    open(str, type) {
      this.$message({
        message: str,
        type: type,
        duration: 800
      });
    },
    save(){
      if(!this.demand || !this.contact){
        this.open('请先将信息填写完整！','warning')
      }else{
        service.adddemand(this.demand).then(res => {
          this.formVisible = true;
          this.open('提交成功','success');
        }).catch(err => {
          this.open('系统错误！','warning');
        })
      }
      

    },
    addDemand(){
      this.open('暂未开通此功能！','warning');
      // this.formVisible = true;
    }
  },
  created(){
  },
  mounted(){
  },
}
</script>

<style lang="less">
@import '../../static/less/right.less';
</style>


// WEBPACK FOOTER //
// src/components/right.vue